import PropTypes from 'prop-types';
import { FormGroup, InlineLabel } from '@celltrak/ui-components';

import { profileInfo } from '../../constants';

import styles from './ProfileViewInfo.module.scss';

const ProfileViewInfo = ({ values }) => (
  <div className={styles.infoContainer}>
    <FormGroup>
      <InlineLabel
        className={styles.label}
        size="sm"
        label={profileInfo.agencyNameLabel}
        id={profileInfo.agencyNameId}
        value={values.agencyName}
      />
    </FormGroup>
    <FormGroup>
      <InlineLabel
        className={styles.label}
        size="sm"
        label={profileInfo.agencyIdLabel}
        id={profileInfo.agencyId}
        value={values.agencyID}
      />
    </FormGroup>
    <FormGroup>
      <InlineLabel
        className={styles.label}
        size="sm"
        label={profileInfo.partnerIdLabel}
        id={profileInfo.partnerId}
        value={values.partnerID}
      />
    </FormGroup>
    <FormGroup>
      <InlineLabel
        className={styles.label}
        size="sm"
        label={profileInfo.partnerAgencyIdLabel}
        id={profileInfo.partnerAgencyId}
        value={values.partnerAgencyID}
      />
    </FormGroup>
    <FormGroup>
      <InlineLabel
        className={styles.label}
        size="sm"
        label={profileInfo.statusLabel}
        id={profileInfo.statusId}
        value={values.active ? 'Active' : 'Inactive'}
      />
    </FormGroup>
  </div>
);

ProfileViewInfo.propTypes = {
  values: PropTypes.shape({
    agencyName: PropTypes.string,
    agencyID: PropTypes.number,
    partnerAgencyID: PropTypes.string,
    partnerID: PropTypes.string,
    active: PropTypes.bool,
  }),
};

ProfileViewInfo.defaultProps = {
  values: {
    agencyName: '',
    agencyID: null,
    partnerAgencyID: '',
    partnerID: '',
    active: false,
  },
};

export default ProfileViewInfo;
